module.exports = __webpack_public_path__ + "img/logotop.5cd79594.png";